import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M44.164 9.621v16.74C70.841 29.817 99.09 51.196 100 90.378 86.878 71.74 70.008 64.17 44.164 63.446v16.838L0 44.953Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
